import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {Week} from './Week';
import {classNames} from '../../../../Support/classNames';
import {CalendarEvent} from '../../../../../Models/CalendarEvent';
import {endOfMonth, startOfMonth} from 'date-fns';
import {PartialWorkout} from '../../../../../Models/PartialWorkout';

interface OwnProps {
    referenceDate: Date;
    ownWorkouts: PartialWorkout[];
    calendarEvents: CalendarEvent[];
    onCreateClick: (date: Date) => void;
    onCalendarEventDateChange: (calendarEvent: CalendarEvent, date: Date) => void;
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
    className?: string;
}

function getNumberOfDaysInMonth(date: Date) {
    //0 is the last day of the previous month
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}

function getDayInWeek(firstDayOfMonth: Date) {
    const number = firstDayOfMonth.getDay() - 1;
    if (number < 0) {
        return 6;
    }
    return number;
}

export const Calendar: FunctionComponent<OwnProps> = ({
    referenceDate,
    ownWorkouts,
    calendarEvents,
    onCalendarEventClick,
    onCalendarEventDateChange,
    onCreateClick,
    className,
}) => {
    const [draggedCalendarEvent, setDraggedCalendarEvent] = useState<CalendarEvent | null>(null);

    const firstDayOfMonth = startOfMonth(referenceDate);
    const lastDayOfMonth = endOfMonth(referenceDate);
    const numberOfDaysInMonth = getNumberOfDaysInMonth(referenceDate);

    const firstDayOfWeek = getDayInWeek(firstDayOfMonth);
    const lastDayOfWeek = getDayInWeek(lastDayOfMonth);

    const days = [];
    for (let i = 0; i < firstDayOfWeek; i++) {
        days.push({
            isEmpty: true,
            date: new Date(Date.UTC(referenceDate.getFullYear(), referenceDate.getMonth(), i)),
        });
    }
    for (let i = 1; i <= numberOfDaysInMonth; i++) {
        days.push({
            isEmpty: false,
            number: i,
            date: new Date(Date.UTC(referenceDate.getFullYear(), referenceDate.getMonth(), i)),
        });
    }
    for (let i = lastDayOfWeek; i < 6; i++) {
        days.push({
            isEmpty: true,
            date: new Date(Date.UTC(referenceDate.getFullYear(), referenceDate.getMonth(), i)),
        });
    }

    const weeks = [];
    for (let i = 0; i < days.length; i += 7) {
        weeks.push(days.slice(i, i + 7));
    }

    return (
        <div className={classNames('calendar-month', className)}>
            <div className="week">
                <div className="days">
                    <div className="week__header">Monday</div>
                    <div className="week__header">Tuesday</div>
                    <div className="week__header">Wednesday</div>
                    <div className="week__header">Thursday</div>
                    <div className="week__header">Friday</div>
                    <div className="week__header">Saturday</div>
                    <div className="week__header">Sunday</div>
                </div>
            </div>
            {weeks.map((week, index) => {
                return (
                    <Week
                        key={index}
                        days={week}
                        ownWorkouts={ownWorkouts}
                        calendarEvents={calendarEvents}
                        onStartDragging={(calendarEvent) => setDraggedCalendarEvent(calendarEvent)}
                        onDrop={(date) => {
                            if (draggedCalendarEvent) {
                                onCalendarEventDateChange(draggedCalendarEvent, date);
                            }
                        }}
                        onCreateClick={onCreateClick}
                        onCalendarEventClick={onCalendarEventClick}
                    />
                );
            })}
        </div>
    );
};
